import { render, staticRenderFns } from "./index_bak.vue?vue&type=template&id=ec757906&scoped=true&"
import script from "./index_bak.vue?vue&type=script&lang=js&"
export * from "./index_bak.vue?vue&type=script&lang=js&"
import style0 from "./index_bak.vue?vue&type=style&index=0&id=ec757906&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec757906",
  null
  
)

export default component.exports